<!--导出字段勾选组件-->
<template>
    <el-button :type="buttonType" size="small" @click="exportFile" style="margin-left: 20px;" :loading="exportButtonLoading">{{buttonName}}</el-button>
</template>
  
  
  <script>
  import axios from 'axios';
  export default {
    name: "ExportFile",
    props: {
        buttonType: {
            type: String,
            default: 'primary',
        },
        buttonName: {
            type: String,
            default: '导出',
        },
        url: {
            type: String,
            required: true,
        },
        params: {
            type: Object,
            required: false,
            value: function () {
                return {};
            }
        },
        filename: {
            type: String,
            required: true,
        },
    },
    data() {
      return {
        //定义变量
        loading: true,
        ExportFormVisible: false,
        is_all: false,
        exportButtonLoading: false,
      };
    },
  
    created: function () {
    },

    methods: {
        exportFile() {
            this.exportButtonLoading = true;
            let params = _.clone(this.params);
            if(params == undefined) params = {};
            console.log(params, this.$store.getters.token);
            params['access-token'] = this.$store.getters.token;
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            });
            axios({
                url: this.url,
                method: 'GET',
                responseType: 'blob',
                params: params
            })
            .then(response => {
                const contentType = response.headers['content-type'];
                if (contentType && contentType.includes('application/json')) {
                    // JSON 响应处理
                    response.data.text().then(jsonText => {
                    const res = JSON.parse(jsonText);
                    // 在这里处理 jsonData
                    if (res.code != 0) {
                        this.$message({
                        message: res.msg,
                        type: 'error'
                        })
                    }
                    })
                }else{
                    const blob = new Blob([response.data]);
                    //获取服务器返回的文件名
                    // const contentDisposition = response.headers['content-disposition'];
                    // const filenameMatch = contentDisposition.match(/filename=(.+)$/);
                    // let filename = '销售数据表.xlsx'; // 默认文件名
                    // if (filenameMatch) {
                    //     filename = filenameMatch[1];
                    // }
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.filename + '.xlsx';
                    link.click();
                }
                this.exportButtonLoading = false;
            })
            .catch(error => {
                this.exportButtonLoading = false;
                console.error('Error fetching file:', error);
            });
        },
    }
  };
  </script>


// WEBPACK FOOTER //
// src/widgets/ExportFile.vue